// Apresentação dos avisos do sino. Puro, sem rede nem React, para ser testado.

/** De quanto em quanto tempo o sino pergunta o contador de não lidas (a v1 não usa SignalR). */
export const POLL_INTERVAL_MS = 60 * 1000;

const SEVERITY_COLORS = { error: 'error', warning: 'warning', info: 'info' };

/** Cor do MUI para a gravidade; qualquer valor desconhecido é informativo. */
export const severityColor = (severity) => SEVERITY_COLORS[severity] || 'info';

export const severityLabel = (severity) => ({ error: 'Erro', warning: 'Atenção' }[severity] || 'Aviso');

/** "agora", "há 5 min", "há 3 h", "ontem" ou a data. `now` vem de fora para o teste não depender do relógio. */
export const formatWhen = (iso, now = new Date()) => {
    if (!iso) return '';
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return '';

    const minutes = Math.floor((now.getTime() - date.getTime()) / 60000);
    if (minutes < 1) return 'agora';
    if (minutes < 60) return `há ${minutes} min`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `há ${hours} h`;

    const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
    const days = Math.round((startOfDay(now) - startOfDay(date)) / 86400000);
    if (days === 1) return 'ontem';
    return date.toLocaleDateString('pt-BR');
};

const GUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** O id do item do catálogo num link de aviso (`/?catalogo=<id>`), ou nulo. Só aceita um Guid: o link vem de fora e não vira rota qualquer. */
export const catalogItemFromLink = (link) => {
    if (!link) return null;
    try {
        const id = new URL(link, 'http://backoffice.local').searchParams.get('catalogo');
        return id && GUID.test(id) ? id : null;
    } catch {
        return null;
    }
};

/** Texto do contador no sino: some quando não há nada, e "99+" quando passa. */
export const badgeCount = (unread) => (unread > 99 ? '99+' : unread > 0 ? String(unread) : '');
